import { render, staticRenderFns } from "./PlatformTelegramOperations.vue?vue&type=template&id=7440744c&scoped=true&"
import script from "./PlatformTelegramOperations.vue?vue&type=script&lang=js&"
export * from "./PlatformTelegramOperations.vue?vue&type=script&lang=js&"
import style0 from "./PlatformTelegramOperations.vue?vue&type=style&index=0&id=7440744c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7440744c",
  null
  
)

export default component.exports